import { Component, cloneElement, Children } from 'react';
export default class DragM extends Component {
    constructor() {
        super(...arguments);
        this.size = {
            clientHeight: 0,
            clientWidth: 0,
        };
        this.position = {
            startX: 0,
            startY: 0,
            dx: 0,
            dy: 0,
            absX: [],
            absY: [],
        };
        this.start = ({ button, offsetX, clientX, offsetY, clientY, pageX, pageY }) => {
            if (button != 0) {
                //只允许左键，右键问题在于不选择conextmenu就不会触发mouseup事件
                return;
            }
            document.addEventListener('mousemove', this.docMove);
            const { dx, dy, absX, absY } = this.position;
            const { clientHeight, clientWidth, offsetTop } = this.modalDom;
            // 兼容 Modal 框过高撑开遮罩导致无法拖动的场景
            const maxHeight = Math.max(clientHeight + offsetTop, document.body.clientHeight);
            const maxWidth = Math.max(clientWidth, document.body.clientWidth);
            if (!absX.length) {
                absX[0] = dx + offsetX - clientX + 20; //兼容padding 10px 20px
                absX[1] = absX[0] + maxWidth - this.size.clientWidth - 1; // 防止滚动条
            }
            if (!absY.length) {
                absY[0] = dy + offsetY - clientY + 10; //兼容padding 10px 20px
                absY[1] = absY[0] + maxHeight - this.size.clientHeight - 1; // 防止滚动条
            }
            this.position.startX = pageX - dx;
            this.position.startY = pageY - dy;
        };
        this.docMove = event => {
            const tx = this.calcLimit(event.pageX - this.position.startX, 'absX');
            const ty = this.calcLimit(event.pageY - this.position.startY, 'absY');
            const transformStr = `translate(${tx}px, ${ty}px)`;
            this.props.updateTransform(transformStr, tx, ty, this.tdom);
            this.position.dx = tx;
            this.position.dy = ty;
        };
        this.calcLimit = (val, key) => {
            if (val < this.position[key][0]) {
                val = this.position[key][0];
            }
            else if (val > this.position[key][1]) {
                val = this.position[key][1];
            }
            return val;
        };
        this.resize = () => {
            this.position.absX = [];
            this.position.absY = [];
        };
        this.docMouseUp = () => {
            document.removeEventListener('mousemove', this.docMove);
        };
        this.setRef = elm => {
            if (elm) {
                this.tdom = elm;
                this.modalContent = elm.parentElement.parentElement.parentElement;
                this.modalDom = this.modalContent.parentElement;
            }
        };
    }
    componentDidMount() {
        if (this.modalContent) {
            this.size.clientHeight = this.modalContent.clientHeight;
            this.size.clientWidth = this.modalContent.clientWidth;
        }
        this.tdom.addEventListener('mousedown', this.start);
        window.addEventListener('resize', this.resize);
        //用document移除对mousemove事件的监听
        document.addEventListener('mouseup', this.docMouseUp);
    }
    componentWillUnmount() {
        this.tdom.removeEventListener('mousedown', this.start);
        window.removeEventListener('resize', this.resize);
        document.removeEventListener('mouseup', this.docMouseUp);
        document.removeEventListener('mousemove', this.docMove);
    }
    render() {
        const { children } = this.props;
        const { style } = children.props;
        const newStyle = Object.assign({}, style, { cursor: 'move', userSelect: 'none' });
        return cloneElement(Children.only(children), {
            ref: this.setRef,
            style: newStyle,
        });
    }
}
